import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { ProductModel } from './../../models/wardrobe.model';
import { SwapItemModalComponent } from 'src/app/components/swap-item-modal/swap-item-modal.component';
import { PriceDiscountModalComponent } from './../../components/price-discount-modal/price-discount-modal.component';

@Component({
  selector: 'shc-counter-offer-modal',
  templateUrl: './counter-offer-modal.component.html',
  styleUrls: ['./counter-offer-modal.component.scss'],
})
export class CounterOfferModalComponent implements OnInit {
  @Input() senderId: number;
  @Input() product: ProductModel;

  constructor(
    protected translate: TranslateService,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    console.log('acscasc');

   }

  async swapItem() {
    // await this.modalCtrl.dismiss();

    const modal = await this.modalCtrl.create({
      component: SwapItemModalComponent,
      componentProps: {
        senderId: this.senderId,
        actualProductId: this.product?.id
      },
      cssClass: 'my-custom-class',
      canDismiss: true,
      id: 'swapItem'
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the SwipeItemModalComponent modal is closed
      this.modalCtrl.dismiss(data, null, 'counterOffer');
    });
    return await modal.present();
  }

  async priceDiscount() {
    // await this.modalCtrl.dismiss();

    const modal = await this.modalCtrl.create({
      component: PriceDiscountModalComponent,
      componentProps: {
        product: this.product,
        senderId: this.senderId
      },
      cssClass: 'my-custom-class',
      canDismiss: true,
      id: 'priceDiscount'
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the PriceDiscountModalComponent modal is closed
      console.log(data);
      this.modalCtrl.dismiss(data, null, 'counterOffer');
    });
    return await modal.present();
  }
}
